module.exports = __webpack_public_path__ + "static/img/Katrina-Gorry.6365bb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Katrina-Gorry.jpg
// module id = UJkM
// module chunks = 0